import * as React from 'react'
import styled from 'styled-components'
import {Button} from '../atoms/Button'
import {Content} from '../atoms/Content/index'
import {Input} from '../atoms/Input'
import {Layout} from '../atoms/Layout'
import {Link} from '../atoms/Link'
import {Nav} from '../atoms/Nav'
import {P} from '../atoms/P'
import {media} from '../utils/media'
import {Success} from '../atoms/Success'
import {Select} from '../atoms/Select'
import {ResetPasswordContainer} from '../organisms/ResetPasswordForm/ResetPasswordContainer'
import {
  RouteComponentProps,
} from 'react-router-dom'

export const UpdatePasswordPage = ({location}: RouteComponentProps) => (
  <Layout>
    <Nav.Bar>
      <Nav.HomeButtonWeb/>
    </Nav.Bar>
    <Content style={{textAlign: 'center'}}>
      <H1>Enter New Password</H1>
      <ResetPasswordContainer location={location}/>
    </Content>
  </Layout>
)

const H1 = styled.h1`

  font-family: Nunito;
  font-size: 24px;
  font-weight: 900;
  color: #12385b;

  ${media.tablet`
    font-size: 54px;
  `}
`



// WEBPACK FOOTER //
// ./src/pages/UpdatePasswordPage.tsx